import { goRequest } from '../utils/httpClientTs';
import {
  FinanceFundsListParams,
  FinanceFundsListResponse,
  FundDetailResponse,
  PatchFundRequest,
  CreateFundNoteRequest,
  PatchFundNoteRequest,
  CreateFundPositionRequest,
  PatchFundPositionRequest,
  CreateFundRequest,
  CreateFundResponse,
} from '../types/financeFunds';

export const getFinanceFundsList = async (
  params: FinanceFundsListParams
): Promise<FinanceFundsListResponse> => {
  let url = `/finance/funds?page_size=${params.page_size}&page=${params.page}`;

  if (params.search) {
    url += `&search=${encodeURIComponent(params.search)}`;
  }
  if (params.order_by) {
    url += `&order_by=${encodeURIComponent(params.order_by)}`;
  }
  if (params.order) {
    url += `&order=${encodeURIComponent(params.order)}`;
  }

  return goRequest<FinanceFundsListResponse>({
    url: url,
    method: 'GET',
  });
};

export const createFund = async (
  data: CreateFundRequest
): Promise<CreateFundResponse> => {
  return goRequest<CreateFundResponse>({
    url: '/finance/funds',
    method: 'POST',
    data,
  });
};

export const getFundDetail = async (
  fundId: string
): Promise<FundDetailResponse> => {
  return goRequest<FundDetailResponse>({
    url: `/finance/funds/${fundId}`,
    method: 'GET',
  });
};

export const patchFund = async (
  fundId: string,
  data: PatchFundRequest
): Promise<void> => {
  await goRequest({
    url: `/finance/funds/${fundId}`,
    method: 'PATCH',
    data,
  });
};

export const createFundNote = async (
  fundId: string,
  data: CreateFundNoteRequest
): Promise<void> => {
  await goRequest({
    url: `/finance/funds/${fundId}/notes`,
    method: 'POST',
    data,
  });
};

export const patchFundNote = async (
  fundId: string,
  noteId: string,
  data: PatchFundNoteRequest
): Promise<void> => {
  await goRequest({
    url: `/finance/funds/${fundId}/notes/${noteId}`,
    method: 'PATCH',
    data,
  });
};

export const deleteFundNote = async (
  fundId: string,
  noteId: string
): Promise<void> => {
  await goRequest({
    url: `/finance/funds/${fundId}/notes/${noteId}`,
    method: 'DELETE',
  });
};

export const createFundPosition = async (
  fundId: string,
  data: CreateFundPositionRequest
): Promise<void> => {
  await goRequest({
    url: `/finance/funds/${fundId}/positions`,
    method: 'POST',
    data,
  });
};

export const patchFundPosition = async (
  fundId: string,
  memberId: string,
  data: PatchFundPositionRequest
): Promise<void> => {
  await goRequest({
    url: `/finance/funds/${fundId}/positions/${memberId}`,
    method: 'PATCH',
    data,
  });
};

export const deleteFundPosition = async (
  fundId: string,
  memberId: string
): Promise<void> => {
  await goRequest({
    url: `/finance/funds/${fundId}/positions/${memberId}`,
    method: 'DELETE',
  });
};
